export class WashingType {
  id: number;
  name: string;
  basketNumber: string;
  basketColour: string;
  temperature: number;

  constructor() {
    this.id = 0;
    this.name = '';
    this.basketNumber = '';
    this.basketColour = '';
    this.temperature = 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/+core/common/model/washing-type.model.ts